import { input } from './data.js';
import { random, clamp } from './math.js';
/** Simple deterministic sparring partner. Not a competitive or learning agent. */
export class Bot {
  constructor(seed = 7341) { this.reset(seed); }
  reset(seed = 7341) { this.rng = random(seed); this.nextDecision = 0; this.intent = input(); this.jumpHold = 0; }
  sample(engine, id = 1) {
    const f = engine.fighters[id], target = engine.fighters[1 - id];
    if (engine.phase !== 'playing' || engine.settings.mode === 'training' || f.ko || !f.stocks) return input();
    const c = input();
    const base = engine.stage.platforms.find(p => p.solid);
    const edge = base.width / 2;
    const dx = target.x - f.x, dy = target.y - f.y;
    if (f.state === 'ledge') return input({ x: -f.ledgeSide, jump: true, jumpHeld: true });
    if (Math.abs(f.x) > edge - 0.5 || f.y < -0.3) {
      c.x = -Math.sign(f.x); c.jumpHeld = true;
      if (f.y < 0.1 && f.vy < 0 && f.jumpsLeft && !f.attack) c.jump = true;
      else if (f.y < -1.7 && !f.recoveryUsed && !f.attack) c.special = true;
      if (f.y > 1.2 && Math.abs(f.x) < edge) c.x = clamp(dx, -1, 1);
      return c;
    }
    c.x = Math.abs(dx) > 1.65 ? Math.sign(dx) : Math.abs(dx) < 0.9 ? -Math.sign(dx) * 0.35 : 0;
    if (f.grounded && Math.abs(dx) < 2.4 && dx * f.facing < 0) c.x = Math.sign(dx) * 0.25;
    if (this.jumpHold > 0) { c.jumpHeld = true; this.jumpHold--; }
    if (engine.frame >= this.nextDecision) {
      const cadence = { easy: 30, normal: 18, hard: 10 }[engine.settings.difficulty];
      this.nextDecision = engine.frame + cadence;
      if ((dy > 1.9 && f.grounded) || (dy > 2.9 && f.vy < 1 && f.jumpsLeft)) { c.jump = true; c.jumpHeld = true; this.jumpHold = 18; }
      if (dy < -2 && f.grounded && f.platformId !== 'base') { c.y = -1; c.jump = true; }
      const threatened = target.attack && Math.abs(dx) < 3;
      const r = this.rng();
      if (threatened && r < (engine.settings.difficulty === 'easy' ? 0.12 : 0.5)) {
        c.shield = f.grounded; c.dodge = !f.grounded && !f.airDodgeUsed;
        this.intent.shield = c.shield;
      } else {
        this.intent.shield = false;
        if (Math.abs(dx) < 2.4 && Math.abs(dy) < 2.6) {
          c.y = dy > 1 ? 1 : dy < -0.8 ? -1 : 0;
          c.attack = r > 0.25 || !f.grounded;
          c.heavy = !c.attack;
          if (Math.abs(dx) > 1.2) c.x = Math.sign(dx);
        }
      }
    } else c.shield = this.intent.shield && Boolean(target.attack) && Math.abs(dx) < 3;
    return c;
  }
}
